import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { RegisterUser } from '../../actions/authActions';
import textWeight from '../../utils/textWeight';

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loadingToapi, setLoadingToapi] = useState();
  const { userType } = location.state || {}; // Access the userType from navigation state
  const { TextWeight } = textWeight();
  // You can set the userType to local state if needed
  const [selectedUserType, setSelectedUserType] = useState(userType || '');
  const [showPopup, setShowPopup] = useState(false);

  const handleContinueClick = () => {
    setShowPopup(true); // Show popup when Continue button is clicked
  };

  const closePopup = () => {
    setShowPopup(false); // Hide popup when close button is clicked
  };

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fullname: '',
      email: '',
      password: '',
      confirmPassword: '',
      phone: '',
      companyName: '',
      collegeName: '',
      companyAddress: '',
      collegeAddress: '',
      termsAndConditions: false,
      // pricing: "",
    },
  });

  const RegisterMutation = RegisterUser(setLoadingToapi, navigate);

  const onSubmit = (data) => {
    setLoadingToapi(true);
    const api_data = {
      email: data.email,
      fullname: data.fullname,
      password: data.password,
      phone: data.phone,
      role: userType,
      fcmToken: 'sldkfjklsdfjkl',
    };

    if (selectedUserType === 'student') {
      api_data.college = data.collegeName;
      api_data.collegeAddress = data.collegeAddress;
    } else {
      api_data.company = data.companyName;
      api_data.companyAddress = data.companyAddress;
    }
    RegisterMutation.mutate(api_data);
  };

  useEffect(() => {
    if (userType) {
      setSelectedUserType(userType); // Initialize selected userType
    }
  }, [userType]);

  // const [isPricingDropdownOpen, setIsPricingDropdownOpen] = useState(false);
  // const pricingOptions = ["Free", "Basic - $10/month", "Premium - $50/month", "Enterprise - $100/month"];
  // const pricingToggleDropdown = () => {
  //     setIsPricingDropdownOpen(!isPricingDropdownOpen);
  // };
  // const handlePricingSelect = (value) => {
  //     setValue("pricing", value);// Update form value
  //     pricingToggleDropdown();
  // };

  return {
    register,
    handleSubmit,
    setValue,
    getValues,
    errors,
    loadingToapi,
    handleContinueClick,
    closePopup,
    showPopup,
    onSubmit,
    selectedUserType,
    navigate,
    TextWeight,
  };
};
